import React, { useState } from "react";
import { Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useUser } from "../contexts/UserContextProvider";
import Logo from "./Logo";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import SideMenu from "./SideMenu";
import MenuIcon from "@mui/icons-material/Menu";
import OrganizationDropdown from "./buttons/OrganizationDropdown";
import styles from "./NavigationBar.module.css";

export default function NavigationBar() {
  const { isAuth } = useUser();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const token = localStorage.getItem("token");

  const toggleDrawer = (newOpen) => {
    setOpen(newOpen);
  };
  // setUserInfo(JSON.parse(localStorage.getItem("userInfo")));
  useEffect(() => {
    const checkAuth = () => {
      if (!token) {
        navigate("/");
      }
    };

    checkAuth();
  }, [isAuth, navigate]);


  const DrawerList = (
    <Box sx={{ width: 300 }} role="presentation">
      <Stack direction="horizontal" gap={4} className="p-3 m-1 border-bottom" onClick={() => toggleDrawer(false)}>
        <Logo withText />
        <DashboardButton />
      </Stack>
      <SideMenu toggleDrawer={toggleDrawer}/>
    </Box>
  );

  return (
    <nav id="navigation" style={{borderBottom: "1px solid #ebebeb"}}>
      <Stack className="py-3 px-4 px-md-5" gap={5} direction="horizontal">
        <div className="d-lg-none" onClick={() => toggleDrawer(true)}>
          <MenuIcon />
        </div>
        <Logo withText className="d-none d-lg-flex" />

        <DashboardButton />
        <Stack
          direction="horizontal"
          gap={2}
          className={`p-1 bg-white rounded-5 ${styles.profileIcon}`}
          style={{ cursor: "pointer" }}
        >
          <OrganizationDropdown />  {/* includes the profile icon */}
        </Stack>
      </Stack>

      {/* drawer */}
      <Drawer open={open} onClose={() => toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </nav>
  );
}

// DashboardButton for the navigation bar
const DashboardButton = () => {
  const navigate = useNavigate();

  return (
    <h6
      style={{ cursor: "pointer" }}
      className="ms-auto mb-0"
      onClick={() => navigate("/home")}
    >
      Dashboard
    </h6>
  );
};

